var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Date",
    d: "M8.711,10.898H6.519v2.192h2.193L8.711,10.898 M13.098,10.898h-2.194v2.192h2.194V10.898 M17.48,10.898h-2.192 v2.192h2.192V10.898 M19.674,3.225h-1.097V1.032h-2.191v2.193H7.615V1.032H5.423v2.193H4.326c-1.217,0-2.192,0.986-2.192,2.192 v15.349c0,1.209,0.982,2.192,2.192,2.192h15.348c1.212,0,2.193-0.983,2.193-2.192V5.417C21.867,4.207,20.886,3.225,19.674,3.225  M19.674,20.766H4.326V8.706h15.348V20.766z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDate);
export default __webpack_public_path__ + "static/media/ic_date.23a4d78f470e2b4dcad51b761ffa52e0.svg";
export { ForwardRef as ReactComponent };